<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Nuovo allegato</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home" title="Dashboard">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item"><a href="/tabelle/articoli" title="articoli">Articoli</a></li>
            <li class="breadcrumb-item active"> {{articoli?.codice}} - {{articoli?.descrizione}}</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->


  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          Nuovo allegato per {{articoli?.codice}} - {{articoli?.descrizione}}
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">
        <form>
          <div class="row">
            <div class="col-6 col-md-4">
              <div class="dx-fieldset-header">Nome allegato</div>
              <dx-text-box [(value)]="nomeAllegato">
                <dx-validator>
                  <dxi-validation-rule type="required" message="Inserire il nome"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>

            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-4">
              <div class="widget-container">
                <div class="dx-fieldset-header">File </div>
                <dx-file-uploader
                  #fileUploader

                  [multiple]="false"
                  accept="*"
                  [(value)]="value"
                  uploadMode="useForm"
                  >
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Selezionare il file"></dxi-validation-rule>
                  </dx-validator>
                </dx-file-uploader>
                <div class="content">
                  @if (value.length > 0) {
                    <div>
                      <h4>Selected Files</h4>
                    </div>
                  }
                  @for (file of value; track file) {
                    <div>
                      <div class="selected-item">
                        Name:
                        <span>{{file.name}}</span><br /> Size:
                        <span>{{file.size}}</span>bytes<br /> Type:
                        <span>{{file.type}}</span><br /> Last Modified Date:
                        <span>{{file.lastModifiedDate}}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

        </form>

        <div class="row">
          <div class="col-6 col-md-4">
            <div class="dx-fieldset">

            </div>
          </div>
        </div>

      </div><!-- /.card-body -->
      <div class="card-footer">
        <dx-button
          stylingMode="contained"
          text="Allega"
          type="normal"
          width="120"
          type="success"
          (onClick)="allegaFile($event, fileUploader.value)">
        </dx-button>
      </div>
    </div>
    <!-- /.card -->

  </section>
</div>

